<template>
    <div class="transferMerchantConfig">
        <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            style="margin-bottom: 10px"
        >
            新增配置
        </el-button>
        <filter-box
            channel="others"
            @reset="resetEvent"
            @search="searchEvent"
        ></filter-box>
        <div class="tableList">
            <el-table
                v-loading="tableLoading"
                :data="tableData"
                style="width: 100%"
                class="table-box"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: '#606266',
                }"
            >
                <el-table-column
                    prop="id"
                    label="ID"
                    min-width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="member_id"
                    label="会员ID"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="wp_serial"
                    label="证书序列号"
                    min-width="200"
                >
                </el-table-column>
                <el-table-column label="详细配置" min-width="300">
                    <template slot-scope="{ row }">
                        <el-tooltip
                            popper-class="detailPopper"
                            effect="dark"
                            :content="formatJson(row.detail_config)"
                            placement="top"
                        >
                            <div
                                style="overflow: hidden; text-overflow: ellipsis"
                            >
                                <span style="white-space: nowrap">
                                    {{ formatJson(row.detail_config) }}
                                </span>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="180">
                    <template slot-scope="{ row }">
                        {{ row.create_time | $unixTimeToDateTime }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="80">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="editEvent(scope.row)"
                        >
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-box">
                <el-pagination
                    @current-change="fetchList"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <transfer-dialog
            :visible.sync="dialogVisible"
            :actionType="dialogType"
            :configData="currentRow"
            @refresh="refreshList"
        ></transfer-dialog>
    </div>
</template>

<script>
import {
    getTransferMerchantConfList,
} from "@/api/config";
import FilterBox from "./components/filterBox.vue";
import TransferDialog from "./components/transferDialog.vue";

export default {
    name: "TransferMerchantConfig",
    components: {
        FilterBox,
        TransferDialog,
    },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            tableLoading: false,
            tableData: [],
            searchParams: {
                member_id: "",
            },
            dialogVisible: false,
            dialogType: "add",
            currentRow: null,
        };
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        formatJson(val) {
            if (!val) return "";
            if (typeof val === "object") return JSON.stringify(val);
            return val;
        },
        async fetchList() {
            let { page, pageSize } = this;
            let { member_id } = this.searchParams;
            let params = {
                page,
                page_size: pageSize,
                member_id,
            };
            this.tableLoading = true;
            const res = await getTransferMerchantConfList(params).catch(
                (e) => e
            );
            this.tableLoading = false;
            if (res.code != 200) return;
            let { list, total } = res.data;
            this.tableData = list || [];
            this.total = parseInt(total);
        },
        addEvent() {
            this.dialogType = "add";
            this.currentRow = null;
            this.dialogVisible = true;
        },
        editEvent(val) {
            this.currentRow = val;
            this.dialogType = "edit";
            this.dialogVisible = true;
        },
        resetEvent(params) {
            this.searchParams = params;
        },
        searchEvent(params) {
            this.page = 1;
            this.searchParams = params;
            this.fetchList();
        },
        refreshList() {
            this.fetchList();
        },
    },
};
</script>

<style lang="scss">
.detailPopper {
    max-width: 80%;
}
</style>
